/**
 * BookingBySlug.jsx — Human-readable booking URL resolver
 *
 * Route: /b/:slug
 *
 * Looks up a class card by its slug field in Firestore, then redirects
 * to /booking/:cardId (the full Firebase booking flow). This gives every
 * class card a clean, shareable URL like:
 *
 *   yoursite.com/b/wheel-throwing-private
 *   yoursite.com/b/pottery-party
 *
 * Admin copies this link from the class card list and shares it directly
 * with customers. The slug is auto-generated from the card title on save.
 */
import { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useCardBySlug } from '../services/firestore';

export default function BookingBySlug() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { card, loading, error } = useCardBySlug(slug);

  useEffect(() => {
    if (loading) return;
    if (card) {
      const qs = searchParams.toString();
      navigate(`/booking/${card.slug}${qs ? `?${qs}` : ''}`, {
        replace: true,
      });
    } else {
      navigate('/', { replace: true });
    }
  }, [card, loading, error, navigate, searchParams]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 74px)',
        background: '#F9F2E9',
      }}
    >
      <p
        style={{
          fontFamily: "'Raleway', sans-serif",
          color: '#9C7A3C',
          fontSize: '0.9rem',
        }}
      >
        Loading class details...
      </p>
    </div>
  );
}
